import Vuex from 'vuex'
import axios from 'axios'
import Vue from 'vue'
import All_MUTATIONS from "./mutation-types";
import ALL_ACTIONS from "./action-types";
import ALL_GETTERS from "./getters-types"
import ALL_MUTATIONS from './mutation-types';
Vue.use(Vuex)

function getSessionValue(key, defaultValue) {
    if (sessionStorage) {
        const value = sessionStorage.getItem(key);

        return value == null ? defaultValue : value;
    }
    return defaultValue
}

function setSessionValue(key, value) {
    if (sessionStorage) {
        sessionStorage.setItem(key, value);
    }
}


const store = new Vuex.Store({
    state: {
        isPublicPage: true,
        legendshow: false,
        searchshow: false,
        config: {
            layerconfig: [],
            soortGM: [],
            soortRM: [],
            soortKP: [],
            soortBG: [],
        },
        gemeenten: [],
        searchParams: {
            gem_code: { label: '', value: '' },
            wijk_code: { label: '', value: '' },
            buurt_code: { label: '', value: '' },
            type: { label: '', value: '' },
            soort: { label: '', value: '' },
        },
        layerConfig: []
    },
    getters: {

        [ALL_GETTERS.GET_SEARCH_PARAMS]: state => () => {
            //TODO: better way to return a copy?
            return JSON.parse(JSON.stringify(state.searchParams));
        },
        [ALL_GETTERS.GET_LAYERCONFIG]: state => () => {
            //TODO: better way to return a copy?
            return JSON.parse(JSON.stringify(state.config.layerconfig.filter(item => (item.defaultVisible || item.userSelectable))));
        },
        [ALL_GETTERS.GET_VISIBLE_LAYERS]: state => () => {
            //TODO: better way to return a copy?
            return state.config.layerconfig.filter(lc => lc.visible).map(lc => lc.name).join(",");
        },
        [ALL_GETTERS.GET_CONFIG]: state => () => {
            return JSON.parse(JSON.stringify(state.config));
        },
        [ALL_GETTERS.GET_LEGEND_SHOW]: state => () => {
            return state.legendshow;
        },
        [ALL_GETTERS.GET_SEARCH_SHOW]: state => () => {
            return state.searchshow;
        },
    },
    mutations: {
        setIsPublicPage(state, isPublicPage) {
            state.isPublicPage = isPublicPage;
        },
        [All_MUTATIONS.UPDATE_VISIBILITY](state, { name, visible }) {
            const lc = state.config.layerconfig.find(lc => lc.name === name)
            if (lc) {
                lc.visible = visible
                setSessionValue(name, visible);
            }
        },
        [All_MUTATIONS.SHOW_SEARCH](state) {
            state.searchshow = true;
        },
        [All_MUTATIONS.HIDE_SEARCH](state) {
            state.searchshow = false;
        },
        [All_MUTATIONS.SHOW_LEGEND](state) {
            state.legendshow = true;
        },
        [All_MUTATIONS.HIDE_LEGEND](state) {
            state.legendshow = false;
        },
        [All_MUTATIONS.SET_CONFIG](state, config) {
            state.config = config
        },
        [All_MUTATIONS.SET_SEARCHPARAMS](state, searchParams) {

            state.searchParams = searchParams
        },
        [All_MUTATIONS.UPDATE_GEMEENTEN](gemeenten) {
            state.gemeenten = gemeenten
        }
    },
    actions: {
        [ALL_ACTIONS.UPDATE_LAYER_VISIBILITY]({ commit, state }, { name, visible }) {


            commit(ALL_MUTATIONS.UPDATE_VISIBILITY, { name, visible })


            const searchParams = state.searchParams;
            searchParams.type = { label: '', value: '' }
            searchParams.soort = { label: '', value: '' }
            commit(ALL_MUTATIONS.SET_SEARCHPARAMS, searchParams)

        },
        [ALL_ACTIONS.CLEAR_SEARCHPARAM]({ commit, state }, key) {

            const searchParams = state.searchParams;
            searchParams[key] = { label: '', value: '' }
            commit(ALL_MUTATIONS.SET_SEARCHPARAMS, searchParams)

        },

        async [ALL_ACTIONS.FETCH_CONFIG](context) {
            const path = context.state.isPublicPage ? "/config" : "/beheer/config";
            const response = await axios.get(path);
            response.data.layerconfig.forEach(lc => {
                if (lc.userSelectable) {
                    const visible = getSessionValue(lc.name, "" + lc.defaultVisible) === "true";
                    lc["visible"] = visible;
                } else {
                    lc["visible"] = lc.defaultVisible;
                }



            })
            context.commit(ALL_MUTATIONS.SET_CONFIG, response.data)
        },

        async [ALL_ACTIONS.FETCH_INFO](context) {

            const data = await axios('/administrativeunit/gemeenten');
            context.commit(ALL_MUTATIONS.UPDATE_GEMEENTEN, data)
        }
        ,

        async [ALL_ACTIONS.FETCH_GEMEENTEN](context) {

            const data = await axios('/administrativeunit/gemeenten');
            context.commit(ALL_MUTATIONS.UPDATE_GEMEENTEN, data)
        }
    }
})

export default store;